<template>
    <rd-container>
        <rd-header :title="$t('dashboard.title')" />
        <div class="row">
            <rd-column :size="$columns.FullWidth">
                <counts-by-day></counts-by-day>
            </rd-column>
        </div>
        <div class="row mt-1">
            <rd-column :size="$columns.SixOnLg">
                <counters></counters>
                <div class="row mt-1">
                    <rd-column :size="$columns.FullWidth" class="acceptance-delays">
                        <!-- TOP 10 największe opóźnienia w Akceptowanych DxList/DxDataGrid -->
                        <top-acceptance-delays></top-acceptance-delays>
                    </rd-column>
                </div>
            </rd-column>
            <rd-column :size="tabletMode ? $columns.FullWidth : $columns.SixOnLg">
                <div class="row content-centered" :class="{ 'mt-1': mobileViewMode}">
                    <active-users class="row-margin"></active-users>
                    <substitutions class="row-margin" :class="{ 'mt-1': mobileViewMode}"></substitutions>
                </div>
                <div class="row mt-1 content-centered">
                    <rd-column class="row-margin" :size="tabletMode ? $columns.FullWidth : $columns.SixOnLg">
                        <!-- Dokumenty ZZ cykliczne oczekująca na odebranie w tym miesiącu - Numer ZZ | Kontrahent | Wartość netto -->
                        <rd-card type="vertical" margins="none">
                            <rd-card-header>
                                <rd-header :title = "$t('dashboard.topAcceptanceDelays.captions.documentsZZcyclical')" 
                                margins="none" 
                                size="medium" />
                            </rd-card-header>
                            <rd-card-content>
                                
                            </rd-card-content>
                        </rd-card>
                    </rd-column>
                    <rd-column class="row-margin" :class="{ 'mt-1': tabletMode}" :size="tabletMode ? $columns.FullWidth : $columns.SixOnLg">
                        <department-monthly-limit></department-monthly-limit>
                        <!-- Wykorzystanie limitów - Nazwa oddziału | Wykorzystane | Pozostało -->
                    </rd-column>
                </div>
            </rd-column>
        </div>
        <div class="row mt-1">
            <rd-column :size="$columns.SixOnLg">
                <!-- Wykres - Liczba zgłoszeń według oddziałów od początku roku -->
                <counts-by-department></counts-by-department>
            </rd-column>
            <rd-column :size="$columns.SixOnLg" :class="{ 'mt-1': mobileViewMode}">
                <!-- Wykres - Wartość kwotowa zgłoszeń i typem według oddziałów od początku roku -->
                <values-by-department-and-type></values-by-department-and-type>
            </rd-column>
        </div>
        <div class="row mt-1">
            <!-- Wykres - Typy zamówień i ich wartość od początku roku z filtrem po oddziale -->
            <rd-column :size="$columns.FullWidth">
                <values-by-order-type></values-by-order-type>
            </rd-column>
        </div>
        <div class="row mt-1">
            <rd-column :size="$columns.FullWidth">
                <!-- Raporty (linki) -->
            </rd-column>
        </div>
    </rd-container>
</template>

<script>
    // @ is an alias to /src
    //import Axios from 'axios';
    //import router from 'vue-router';
    //import sideNav from '../components/sideNav/Index'
    import { mapFields } from 'vuex-map-fields';
    import { mapState, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import CountsByDay from './CountsByDay';
    import Counters from './Counters';
    import ActiveUsers from './ActiveUsers';
    import Substitutions from './Substitutions';
    import DepartmentMonthlyLimit from './DepartmentMonthlyLimit';
    import TopAcceptanceDelays from './TopAcceptanceDelays';
    import CountsByDepartment from './CountsByDepartment';
    import ValuesByDepartmentAndType from './ValuesByDepartmentAndType';
    import ValuesByOrderType from './ValuesByOrderType';

    const name = "processesStores/pzzDashboardStores/indexStore";

    export default {
        name: 'pzzDashboard',
        created() {
            window.addEventListener("resize", this.handleResize);
            this.handleResize();
        },
        data() {
            return {
                mobileViewMode: false,
                tabletMode: false,
                window: {
                    width: 0,
                },
            }
        },
        computed: {
        },
        methods: {
            handleResize() {
                this.window.width = window.innerWidth;
            },
        },
        mounted() {
        },
        watch: {
            "window.width": function (width) {
                width < 980 ? this.mobileViewMode = true : this.mobileViewMode = false;
                (width > 765 && width < 980) ? this.tabletMode = true : this.tabletMode = false;
            },
        },
        destroyed() {
            window.removeEventListener("resize", this.handleResize);
        },
        components: {
            CountsByDay,
            Counters,
            ActiveUsers,
            Substitutions,
            TopAcceptanceDelays,
            DepartmentMonthlyLimit,
            CountsByDepartment,
            ValuesByDepartmentAndType,
            ValuesByOrderType
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
<style scoped lang="scss">
@media (min-width: 765px) and (max-width: 980px) {
    .start-xs > .row {
        flex-direction: column !important;

        > .col-sm-6 > .row {
            gap: 1rem;
            width: 100%;
            justify-content: center;
        }
    }

    .acceptance-delays {
        flex-basis: 95%;
    }

    .row-margin {
        flex-basis: 95%;
    }

    .content-centered {
        justify-content: center;
    }
}
</style>